import type { ReactNode } from 'react';
import { Mail } from 'lucide-react';

export interface GmailMessageCardProps {
  fromName: string | null;
  fromEmail: string;
  subject: string | null;
  internalDate: string;
  badge?: ReactNode;
  actions: ReactNode;
}

export function GmailMessageCard(props: GmailMessageCardProps) {
  const date = new Date(props.internalDate).toLocaleString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
  return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex items-start gap-3">
        <Mail className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <div className="font-medium truncate">
              {props.fromName ?? props.fromEmail}
              {props.fromName && (
                <span className="text-gray-500 font-normal ml-2 text-sm">{props.fromEmail}</span>
              )}
            </div>
            <span className="text-xs text-gray-500 flex-shrink-0">{date}</span>
          </div>
          <div className="text-sm text-gray-700 mt-1 truncate">{props.subject ?? '(sans objet)'}</div>
          {props.badge && <div className="mt-2">{props.badge}</div>}
          <div className="mt-3">{props.actions}</div>
        </div>
      </div>
    </div>
  );
}
